"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var CloseIcon = function (_a) {
    var className = _a.className;
    return (react_1.default.createElement("svg", { viewBox: "0 0 16 16", className: className },
        react_1.default.createElement("path", { fill: "#64666A", d: "M4.14 11.184a.48.48 0 00.68.678l3.179-3.18 3.202 3.203a.48.48 0 00.68-.679L8.677 8.004l3.184-3.185a.48.48 0 10-.678-.678L7.998 7.325 4.836 4.162a.48.48 0 10-.68.678L7.32 8.004l-3.18 3.18z" })));
};
exports.default = CloseIcon;
